import useAuth from 'hooks/useAuth';

export default function useSendText() {
  const { functions } = useAuth();
  const clientTextSend = functions.httpsCallable('clientTextSend');

  const sendText = async (contactId: string, body: string) => {
    const message = await clientTextSend({ contactId, body });
    return message;
  };

  return sendText;
}
